import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import {
  InfoGridComponent,
  InfoGridItem,
} from '@3ddv/software-division-components/backoffice/info-grid';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription, take } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { UtilsService } from '../../../services/utils.service';
import { Event } from '../../models/event.model';
import { EventsService } from '../../services/events.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css'],
  imports: [FormsModule, BoDialogComponent, ButtonComponent, InfoGridComponent],
})
export class ViewComponent implements OnInit, OnDestroy {
  private dialogRef = inject<BrnDialogRef<Event>>(BrnDialogRef);
  private utils = inject(UtilsService);
  private eventService = inject(EventsService);
  private loader = inject(LoaderService);
  private datePipe = new DatePipe('en-US');

  readonly eventId = input.required<number | string>();

  private subscriptions: Array<Subscription>;
  public data: Event;
  public hashValidator = {
    buyerTypeName: false,
    buyerTypeId: false,
  };
  public postImage: File;
  public imagePreview: any;

  public get infoItems(): InfoGridItem[] {
    return [
      { label: 'ID', value: this.data.pvEventId },
      { label: 'Event Code', value: this.data.code },
      { label: 'Description', value: this.data.description },
      {
        label: 'Date',
        value: this.datePipe.transform(this.data.date, 'medium'),
      },
    ];
  }

  constructor() {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    let eventId = this.eventId();
    if (typeof eventId === 'string') {
      eventId = parseInt(eventId);
    }
    if (typeof eventId === 'number') {
      const g$ = this.loader.track(this.eventService.get$(eventId)).subscribe({
        next: response => {
          this.data = response.data;
        },
        error: err => {
          console.log(err);
        },
      });
      this.subscriptions.push(g$);
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  public onDismiss() {
    this.dialogRef.close();
  }

  public onConfirm() {
    let hasErrors = this.checkInputs(this.data);
    if (hasErrors) return;
    this.eventService
      .updateDetails$(this.data.id, this.data, this.postImage)
      .pipe(take(1))
      .subscribe(response => {
        this.dialogRef.close(response.data);
      });
  }

  private checkInputs(instance: Event): boolean {
    let hasErrors = false;
    Object.keys(this.hashValidator).forEach(
      key => (this.hashValidator[key] = false)
    );
    if (this.utils.isEmpty(instance.defaultBuyerTypeName)) {
      this.hashValidator.buyerTypeName = true;
      hasErrors = true;
    } else {
      this.hashValidator.buyerTypeName = false;
    }
    if (!this.utils.onlyHasNumbers(instance.defaultBuyerType)) {
      this.hashValidator.buyerTypeId = true;
      hasErrors = true;
    } else {
      this.hashValidator.buyerTypeId = false;
    }

    return hasErrors;
  }

  public onFileChange(event) {
    this.postImage = event.target.files[0];
    var reader = new FileReader();
    this.imagePreview = null;
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = _event => {
      this.imagePreview = reader.result;
    };
  }

  public removeImage() {
    this.data.urlImage = null;
    this.postImage = null;
    this.imagePreview = null;
  }
}
